import { Injectable } from '@angular/core';
import { Log } from '../models/log.model';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';
import { cmsComponent, cmsComponentExtra, cmsComponentFolder, cmsComponentImage, cmsComponentLink, cmsComponentText } from '../models/cms-component.model';

@Injectable({ providedIn: 'root' })
export class cmsService {
  apiHost: string = environment.apiHost;

  constructor(private http: HttpClient, private globalService: GlobalService) {}

  loadComponents(): Promise<cmsComponent[]> {
    let promise = new Promise<cmsComponent[]>((resolve, reject) => {
      return this.http
        .get<cmsComponent[]>(this.apiHost + '/CMSComponent/loadComponents')
        .toPromise() 
        .then( 
          (data) => {  
            if (data != null)
              resolve(data);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Components!');
          }
        );
    });
    return promise;   
  }

  loadComponent(id): Promise<cmsComponent> {
    let promise = new Promise<cmsComponent>((resolve, reject) => {
      return this.http
        .get<cmsComponent>(this.apiHost + '/CMSComponent/loadComponent?id=' + id)
        .toPromise() 
        .then( 
          (data) => {  
            if (data != null)
              resolve(data);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Component!');
          }
        );
    });
    return promise;   
  }  

  addComponentImage(componentImage: cmsComponentImage): Promise<cmsComponentImage> {
    let promise = new Promise<cmsComponentImage>((resolve, reject) => {
      return this.http
        .post<cmsComponentImage>(this.apiHost + '/CMSComponent/AddComponentImage', componentImage)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)  
              resolve(componentImage);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Add Component Image!');
          }
        );
    });
    return promise;   
  }

  deleteComponentImage(componentImage: cmsComponentImage): Promise<cmsComponentImage> {
    let promise = new Promise<cmsComponentImage>((resolve, reject) => {
      return this.http
        .post<cmsComponentImage>(this.apiHost + '/CMSComponent/deleteComponentImage', componentImage)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(componentImage);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Delete Component Image!');
          }
        );
    });
    return promise;   
  }

  loadComponentImages(): Promise<cmsComponentImage[]> {
    let promise = new Promise<cmsComponentImage[]>((resolve, reject) => {
      return this.http
        .get<cmsComponentImage[]>(this.apiHost + '/CMSComponent/loadComponentImages')
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(data);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Component Images!');
          }
        );
    });
    return promise;   
  }

  saveComponent(component: cmsComponent, priority: number): Promise<cmsComponent> {
    let promise = new Promise<cmsComponent>((resolve, reject) => {
      return this.http
        .post<cmsComponent>(this.apiHost + '/CMSComponent/UpdateComponent?priority=' + priority.toString(), component)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(data);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Save Component!');
          }
        );
    });
    return promise;   
  }

  saveExtra(extra: cmsComponentExtra): Promise<cmsComponentExtra> {
    let promise = new Promise<cmsComponentExtra>((resolve, reject) => {
      return this.http
        .post<cmsComponentExtra>(this.apiHost + '/CMSComponent/SaveExtra', extra)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(data);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Save Extra!');
          }
        ); 
    });
    return promise;   
  }  

  saveTextButtons(textButton: cmsComponentText): Promise<cmsComponentText> {
    let promise = new Promise<cmsComponentText>((resolve, reject) => {
      return this.http
        .post<cmsComponentText>(this.apiHost + '/CMSComponent/SaveTextButtons', textButton)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(data);
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Save Text Button!');
          }
        );
    });
    return promise;   
  }     

  loadExtra(elementId: number, isFolder: boolean = false): Promise<cmsComponentExtra> {
    let promise = new Promise<cmsComponentExtra>((resolve, reject) => {
      return this.http
        .get<cmsComponentExtra>(this.apiHost + '/CMSComponent/LoadExtra?ElementId=' + elementId + '&IsFolder=' + isFolder.toString())
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Extra!');
          }
        );
    });
    return promise;   
  }     

  loadTextButtons(elementId: number, isFolder: boolean = false): Promise<cmsComponentText> {
    let promise = new Promise<cmsComponentText>((resolve, reject) => {
      return this.http
        .get<cmsComponentText>(this.apiHost + '/CMSComponent/LoadTextButtons?ElementId=' + elementId + '&IsFolder=' + isFolder.toString())
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Text Buttons!');
          }
        );
    });
    return promise;   
  }     

  loadLinks(Id: number, isFolder: boolean): Promise<cmsComponentLink[]> {
    let promise = new Promise<cmsComponentLink[]>((resolve, reject) => {
      return this.http
        .get<cmsComponentLink[]>(this.apiHost + '/CMSComponent/LoadLinks?Id=' + Id + '&isFolder=' + isFolder)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Links!');
          }
        );
    });
    return promise;   
  }     


  loadLink(linkId: number): Promise<cmsComponentLink> {
    let promise = new Promise<cmsComponentLink>((resolve, reject) => {
      return this.http
        .get<cmsComponentLink>(this.apiHost + '/CMSComponent/LoadLink?LinkId=' + linkId)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Link!');
          }
        );
    });
    return promise;   
  }     

  updateLink(link: cmsComponentLink): Promise<cmsComponentLink> {
    let promise = new Promise<cmsComponentLink>((resolve, reject) => {
      return this.http
        .post<cmsComponentLink>(this.apiHost + '/CMSComponent/UpdateLink', link)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Add/UpdateLink Link!');
          }
        );
    });
    return promise;   
  }      

  deleteLink(linkId: number): Promise<cmsComponentLink> {
    let promise = new Promise<cmsComponentLink>((resolve, reject) => {
      return this.http
        .post<cmsComponentLink>(this.apiHost + '/CMSComponent/DeleteLink?LinkId=' + linkId, null)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Delete Link!');
          }
        );
    });
    return promise;   
  }      

  loadFolders(Id: number, isFolder: boolean): Promise<cmsComponentFolder[]> {
    let promise = new Promise<cmsComponentFolder[]>((resolve, reject) => {
      return this.http
        .get<cmsComponentFolder[]>(this.apiHost + '/CMSComponent/LoadFolders?Id=' + Id + '&isFolder=' + isFolder)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Folders!');
          }
        );
    });
    return promise;   
  }     


  loadFolder(folderId: number): Promise<cmsComponentFolder> {
    let promise = new Promise<cmsComponentFolder>((resolve, reject) => {
      return this.http
        .get<cmsComponentFolder>(this.apiHost + '/CMSComponent/LoadFolder?FolderId=' + folderId)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Load Folder!');
          }
        );
    });
    return promise;   
  }     

  updateFolder(folder: cmsComponentFolder): Promise<cmsComponentFolder> {
    let promise = new Promise<cmsComponentFolder>((resolve, reject) => {
      return this.http
        .post<cmsComponentFolder>(this.apiHost + '/CMSComponent/UpdateFolder', folder)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Add/UpdateFolder Folder!');
          }
        );
    });
    return promise;   
  }      

  deleteFolder(folderId: number): Promise<cmsComponentFolder> {
    let promise = new Promise<cmsComponentFolder>((resolve, reject) => {
      return this.http
        .post<cmsComponentFolder>(this.apiHost + '/CMSComponent/DeleteFolder?FolderId=' + folderId, null)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)   
              resolve(data);  
            else
              resolve(null);
          },
          (msg) => {
            reject('Internal Error: Delete Folder!');
          }
        );
    });
    return promise;   
  }      

}
 